import { call, put, takeLatest } from 'redux-saga/effects';
import {
  ALERT_SETTINGS_CHANGE_REQUEST,
  alertSettingsChangeSuccess,
  alertSettingsChangeFail,
  ALERT_SETTINGS_SAVE_REQUEST,
} from '../actions/alert-settings';
import { promptToast } from '../../../../components/toast-container/actions';
import { updateAlertSetting } from '../helpers/api';

function* saveAlertSetting(setting) {
  try {
    const response = yield call(
      updateAlertSetting,
      setting.setting,
      setting.value
    );

    if (response.errors) {
      throw new Error(response.errors[0].code);
    }

    yield put(alertSettingsChangeSuccess(setting));
  } catch (e) {
    yield put(alertSettingsChangeFail(setting));
    throw new Error(e);
  }
}

export function* handleSettingsAction(action) {
  switch (action.type) {
    case ALERT_SETTINGS_SAVE_REQUEST: {
      const keys = Object.keys(action.setting);

      for (let i = 0; i < keys.length; i += 1) {
        yield call(saveAlertSetting, {
          setting: keys[i],
          value: action.setting[keys[i]],
        });
      }
      yield put(
        promptToast(
          'success',
          window.APP_GLOBALS.t('account', 'settings.saved')
        )
      );

      break;
    }

    case ALERT_SETTINGS_CHANGE_REQUEST: {
      yield call(saveAlertSetting, action.setting);

      yield put(
        promptToast(
          'success',
          window.APP_GLOBALS.t('account', 'settings.saved')
        )
      );
      break;
    }
    default: {
      break;
    }
  }
}

function* mySaga() {
  yield takeLatest([ALERT_SETTINGS_SAVE_REQUEST], handleSettingsAction);
  yield takeLatest([ALERT_SETTINGS_CHANGE_REQUEST], handleSettingsAction);
}

if (IS_BROWSER) {
  window.registerSaga(mySaga);
}

export default mySaga;
